import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { Route, Routes } from "react-router-dom";
import { ObjectiveContext } from "./context";
import { FETCH_OBJECTIVE_YEARS } from "./graphql";
import TeamDetail from "./TeamDetail";
import TeamsPage from "./TeamsPage";

const ObjectivePage = () => {
  const { loading, error, data } = useQuery(FETCH_OBJECTIVE_YEARS);

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  // reverse the years so that the most recent year is first in the list
  const years = [...data.objectiveYears].sort((a, b) => b - a);

  return (
    <ObjectiveContext.Provider value={{ years }}>
      <Routes>
        <Route>
          <Route index element={<TeamsPage />} />
          <Route path=":teamId" element={<TeamDetail />} />
        </Route>
      </Routes>
    </ObjectiveContext.Provider>
  );
};

export default ObjectivePage;
